import { useEventDebuggerTableContext } from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';
import buildEmptyPayloadCondition from './buildEmptyPayloadCondition';

export default function usePayloadConditions() {
  const { payloadConditions, setPayloadConditions } = useEventDebuggerTableContext();

  const addCondition = () => {
    setPayloadConditions(currentConditions => [...currentConditions, buildEmptyPayloadCondition()]);
  };

  const updateCondition = updatedCondition => {
    setPayloadConditions(currentConditions =>
      currentConditions.map(condition => (condition.id === updatedCondition.id ? updatedCondition : condition))
    );
  };

  const removeCondition = conditionId => {
    setPayloadConditions(currentConditions => currentConditions.filter(condition => condition.id !== conditionId));
  };

  return { payloadConditions, addCondition, updateCondition, removeCondition };
}
